<template>
  <fieldset>
    <div class="mb-3">
      <div class="input-group mb-1">
        <div class="input-group-prepend">
          <div class="input-group-text">Visning</div>
        </div>
        <select class="custom-select" required v-model="mode" @change="onUpdate">
          <option value="hidden">Dold</option>
          <option value="inline">Direkt på kundsidan</option>
          <option value="popup">Länk till popup på kundsidan</option>
        </select>
      </div>

      <p class="small">
        <code>Dold</code> används enbart för Mötesbokning
      </p>
    </div>

    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <div class="input-group-text">Bokningslänk</div>
      </div>
      <input type="url" class="form-control" required pattern="^https://calendly.com/.+" v-model="schedulingUrl" @input="onUpdate">
    </div>
    <p class="small mb-3">
      T.ex. <code>https://calendly.com/jane-doe</code>. Kan även sättas på varje säljares profil.
    </p>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const schedulingUrl = ref(null);
const mode = ref(null);
const serializedValue = computed(() => {
  return {
    scheduling_url: schedulingUrl.value,
    mode: mode.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    schedulingUrl.value = modelValue.value.scheduling_url;
    mode.value = modelValue.value.mode ?? 'inline';
  }
}, {
  immediate: true
});
</script>
